import { BaseActionObject, ResolveTypegenMeta, ServiceMap } from "xstate";
import { service } from "./services";
import { MachineOptionsServices } from "../types/services.type";
import UniMachineModalElement from "../element";
import { CustomEventObject, TEvent } from "../types/types";
const machineElement = new UniMachineModalElement();
export function MiddleWareServices<
  Context,
  EventType extends CustomEventObject,
  Action extends BaseActionObject
>(
  services: MachineOptionsServices<
    Context,
    ResolveTypegenMeta<any, EventType, Action, ServiceMap>,
    any,
    any,
    any
  >
) {
  const servicesDefine = {} as any;

  if (services && Object.keys(services).length) {
    for (let i = 0; i < Object.keys(services).length; i++) {
      const key = Object.keys(services)[i];
      try {
        servicesDefine[key] = async (ctx: Context, e: TEvent<EventType>) =>
          await service<Context, EventType>(ctx, e, { services, index: i });
      } catch (err) {
        machineElement.Loading(false);
        return Promise.reject({ code: 500, message: "Lỗi hệ thống!" });
      }
    }
    return servicesDefine;
  }
}
